import { QueryClient } from '@tanstack/react-query';

// Shared TanStack Query client (GUNDI-5787 pilot). Retries and automatic
// refetches are off so a migrated fetch behaves like the hand-written one it
// replaces: one request, no retry on failure, no refetch on focus/reconnect.
export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
      },
    },
  });

export const queryClient = createQueryClient();

// How long shared account data (your profile, the workspace list) is reused
// before a page that needs it asks again. Saves made in the portal refresh it
// at once; this only bounds how long a change made elsewhere (another admin
// changing your role or memberships) takes to show.
export const ACCOUNT_DATA_STALE_MS = 5 * 60 * 1000;
